const doc = [({"zh_tw":({"adminComponentHotelWaitingList":({"hotelWaitingListIndexTitle":"空缺等候名單"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;